import React from "react";
import DefaultAvatar from "./DefaultAvatar";
import LightTheme from "../theme/LightTheme";

interface Props {
  url?: string;
  name: string;
}

const AttendeeAvatar = ({ url, name }: Props) => {
  if (!url || url.length === 0 || url.includes("WOLAnonProfile.png")) {
    return <DefaultAvatar name={name} />;
  }

  return (
    <>
      <img src={url} alt="avatar" />
      <style jsx>{`
        img {
          height: 40px;
          width: 40px;
          background: ${LightTheme.gradientBackground};
          border-radius: 50%;
        }
      `}</style>
    </>
  );
};

export default AttendeeAvatar;
